var advance = function advance() {
 
    if(typeof quickAddButton == 'function'){
      quickAddButton();
    }

  $('.pro_name').matchHeight({property: 'height'});
  }

  var infinitescroll = {
    scolljs: function(){
      var endlessScroll = new Ajaxinate({
        container: '#product-grid',
        pagination: '#AjaxinatePagination',
        loadingText: document.getElementById('AjaxinatePagination').dataset.text,
        callback: advance,
        //offset: 200
      });
    }
  }
  infinitescroll.scolljs();

  document.addEventListener('scroll', function(e) {
  	var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
	sessionStorage.scrollPos = document.documentElement.scrollTop;
	sessionStorage.totalpage = totalpage;
  });
  if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
	var scrollTop=sessionStorage?.getItem('scrollPos')
	document.documentElement.scrollTop = scrollTop ??  document.body.scrollTop;
    window.scrollTo(0,0);
	scrollManualy(scrollTop);
	function scrollManualy(scrollTop){
		scrollTop = parseInt(scrollTop);
		window.scrollTo(0,scrollTop)
	 }
  }

 $(window).on('scroll', function(){
    var t_os = $('.collection_filter_bar').offset().top - 67,
        s_top = $(window).scrollTop();
    if (s_top >= t_os){
		$('#shopify-section-header').addClass('no_sticky');
    $('.collection_filter_bar').addClass('sticky_top');
      $('body').addClass('sticky_bar');      
    }
    else{
    	$('#shopify-section-header').removeClass('no_sticky');
    $('.collection_filter_bar').removeClass('sticky_top');
        $('body').removeClass('sticky_bar');
    }
    });

 $(window).on('scroll', function(){
    var filter_bar_offset = $('.collection_filter_bar').offset().top,
        s_top = $(window).scrollTop();
    if (s_top >= filter_bar_offset){
    $('body').addClass('sticky_top_0');
    }
    else{
    $('body').removeClass('sticky_top_0');
    }
    });
  


    function saveLoadedProducts() {
      var loadedProducts = document.querySelector("#product-grid").innerHTML;
      sessionStorage.setItem('loadedProducts', loadedProducts);
      var scrollPosition = window.scrollY;
      sessionStorage.setItem('scrollPosition', scrollPosition);
      sessionStorage.setItem('collectionURL', window.location.href);
    
      var ajaxinatePagination = document.querySelector("#AjaxinatePagination a");
      if (ajaxinatePagination) {
        sessionStorage.setItem('ajaxinateHref', ajaxinatePagination.href);
        sessionStorage.setItem('ajaxinatePage', ajaxinatePagination.dataset.page);
      }
    }
    
    function restoreState() {
      if (window.location.pathname.includes('/collections')) {
        
        var scrollPosition = sessionStorage.getItem('scrollPosition');
        var loadedProducts = sessionStorage.getItem('loadedProducts');
        var collectionURL = sessionStorage.getItem('collectionURL');
        var ajaxinateHref = sessionStorage.getItem('ajaxinateHref');
        var ajaxinatePage = sessionStorage.getItem('ajaxinatePage');
        console.log(ajaxinateHref, ajaxinatePage);
        
        if (loadedProducts && collectionURL === window.location.href) {
          document.querySelector("#product-grid").innerHTML = loadedProducts;
          sessionStorage.removeItem('loadedProducts');
        }
        if (scrollPosition && collectionURL === window.location.href) {
          window.scrollTo(0, scrollPosition);
          sessionStorage.removeItem('scrollPosition');
        }
        if (ajaxinateHref && ajaxinatePage && collectionURL === window.location.href) {
          setTimeout(function() {
            var ajaxinatePagination = document.querySelector("#AjaxinatePagination a");
            if (ajaxinatePagination) {
              ajaxinatePagination.href = ajaxinateHref;
              ajaxinatePagination.dataset.page = ajaxinatePage;
              sessionStorage.removeItem('ajaxinateHref');
              sessionStorage.removeItem('ajaxinatePage');
            }
          }, 1000);
        }
      }
    }
    
    document.addEventListener('DOMContentLoaded', restoreState);
    
    document.addEventListener('click', function(event) {
      if (event.target.closest('.snippet-product-grid a')) {
        saveLoadedProducts();
      }
    });
    
    window.addEventListener('beforeunload', function() {
      sessionStorage.setItem('scrollPosition', window.scrollY);
    });
    
    document.querySelectorAll('.navigation_collection a').forEach(anchor => {
      anchor.addEventListener('click', function() {
        sessionStorage.clear();
      });
    });
    
    window.addEventListener('pageshow', function(event) {
      if (event.persisted) {
        restoreState();
      }
    });